import { ReactNode } from 'react';
import cn from 'classnames';

import styles from './dropdown.module.css';

interface DropdownProps {
  children: ReactNode;
}

export default function Dropdown({ children }: DropdownProps) {
  return (
    <div
      className={cn(
        `flex-1 mx-auto flex bg-white flex-nowrap flex-col justify-center lg:flex-row lg:shadow-dropdown lg:border border-catskill-white lg:rounded-lg`,
        styles.dropdown,
      )}
    >
      {children}
    </div>
  );
}
